<template>
  <div
    class="relative flex flex-col items-stretch h-full overflow-auto transition-all bg-transparent border-l-8 border-r-8 rounded-box"
    :class="{
      'border  border-1': step == 1,
      'ring-0 border-none': step >= 2,
      'border-rouge ': id == 1,
      'border-vert': id == 2,
      'border-bleu': id == 3
    }"
  >
    <div
      class="absolute top-0 right-0 hidden p-2 font-bold tracking-wide bg-white border-2 border-t-0 border-r-0 rounded-lg rounded-t-none rounded-r-none rounded-tr-xl"
      :class="{
        'border-rouge text-rouge ': id == 1,
        'border-vert  text-vert': id == 2,
        'border-orange text-orange': id == 3,
        'bg-secondary/30': dragover
      }"
    >
      <span v-if="dragover">Lacher ici pour catégorisé comme </span>
      <span v-if="id == 1">Impact</span>
      <span v-if="id == 2">Effet</span>
      <span v-if="id == 3">Produit</span>
    </div>
    <BoardLevel
      :results="level1"
      :selected="selected"
      :step="step"
      :type="id"
      :level="1"
      @droppedresult="droppedResult"
      @selected="emitSelected"
      @positionupdate="addKnownPosition"
    />
    <BoardLevel
      :class="{
        'border-t border-b  border-dashed': step == 1,
        'border-rouge ': id == 1,
        'border-vert': id == 2,
        'border-bleu': id == 3
      }"
      :results="level2"
      :selected="selected"
      :step="step"
      :type="id"
      :level="2"
      @droppedresult="droppedResult"
      @selected="emitSelected"
      @positionupdate="addKnownPosition"
    />
    <BoardLevel
      :results="level3"
      :selected="selected"
      :step="step"
      :type="id"
      :level="3"
      @droppedresult="droppedResult"
      @selected="emitSelected"
      @positionupdate="addKnownPosition"
    />
  </div>
</template>

<script>
import BoardLevel from "@/components/MR/BoardLevel.vue";
export default {
  name: "Board",
  components: { BoardLevel },
  props: {
    id: { type: Number, required: true },
    results: { type: Array, required: true },
    step: { type: Number, required: true },
    selected: { type: Array, default: new Array() }
  },
  data() {
    return {
      dragover: false,
      knownPositions: [],
      levelPositions: {}
    };
  },

  watch: {
    /**
      results(value) {
        console.log("Value changed");
        this.knownPositions = this.knownPositions.filter(x =>
          value.map(y => y.resultID).includes(x.resultID)
        );
        this.$emit("report", { id: this.id, positions: this.knownPositions });
      },
    */

    step() {
      this.knownPositions = [];
    }
  },

  computed: {
    level1() {
      return this.results.filter(x => [0, 1].includes(x.levelOfResult ?? 1));
    },
    level2() {
      return this.results.filter(x => [2].includes(x.levelOfResult ?? 1));
    },
    level3() {
      return this.results.filter(x => [3].includes(x.levelOfResult ?? 1));
    }
  },
  methods: {
    addKnownPosition(positions, level) {
      /*  console.log("Hello Position received");
      console.log(event); */
      this.levelPositions[level] = positions;
      //this.knownPositions = [...this.knownPositions, ...event];
      this.$emit("report", {
        id: this.id,
        positions: window._.flatten(Object.values(this.levelPositions))
      });
    },
    emitSelected(...e) {
      if (this.step != 2) return;
      this.$emit("selected", ...e);
    },
    droppedResult(resultID, resultType, resultLevel) {
      //Recherche des element du niveau precédent
      if (resultLevel > 1) {
        const fil = this.results.filter(
          x =>
            [
              resultLevel - 1,
              resultLevel == 2 ? resultLevel - 2 : resultLevel - 1
            ].includes(x.levelOfResult) && x.id != resultID
        );
        if (!fil.length) {
          this.$swal.fire({
            icon: "error",
            title:
              "Vous ne pouvez pas ajouter un résultat au Niveau " +
              resultLevel +
              " sans avoir aumoins un résultat du Niveau " +
              (resultLevel - 1)
          });
          return;
        }
      }

      this.$emit("settype", resultID, resultType, resultLevel);
    }
  }
};
</script>
